import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { deeplinkApi as apiConfig } from '../../../axiosConfig';

export const reloadCache = createAsyncThunk(
  'cacheReload',
  async ({ payload }, { rejectWithValue }) => {
    try {
      const { data } = await apiConfig.post('/internal/cache/delete', payload);
      return data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

const legacyPaymentOptionsCacheReloadSlice = createSlice({
  name: 'legacyPaymentOptionsCacheReload',
  initialState: {},
  reducers: {},
  extraReducers: {},
});

export const legacyPaymentOptionsCacheReloadActions =
  legacyPaymentOptionsCacheReloadSlice.actions;

export default legacyPaymentOptionsCacheReloadSlice.reducer;
